// extracted by mini-css-extract-plugin
export default {"barchart":"styles_barchart__leUbk"};